import { Link, LinkProps } from "@tanstack/react-router";
import { ReactNode } from "react";
import TooltipHover from "../ui/TooltipHover";

type LinksLocal = {
  tooltipText: string;
  route: LinkProps["to"];
  params?: LinkProps["params"];
  icon: ReactNode;
};

type LinksExternal = {
  tooltipText: string;
  route: string;
  icon: ReactNode;
};

export const SidebarLinksLocal = ({
  tooltipText,
  route,
  params,
  icon,
  ...props
}: LinksLocal) => {
  return (
    <TooltipHover text={tooltipText}>
      <Link
        {...props}
        to={route}
        params={params}
        className="flex p-1 transition-colors text-brand-gray-400 hover:text-brand-gray-900  dark:text-brand-gray-300 dark:hover:text-brand-gray-100"
        activeProps={{
          className: "text-brand-gray-800 dark:text-brand-gray-50"
        }}
        activeOptions={{
          exact: true
        }}
      >
        {icon}
      </Link>
    </TooltipHover>
  );
};

export const SidebarLinksExternal = ({
  tooltipText,
  route,
  icon
}: LinksExternal) => {
  return (
    <TooltipHover text={tooltipText}>
      <a
        href={route}
        className="inline-block p-0.5 transition-colors text-brand-gray-400 hover:text-brand-gray-900  dark:text-brand-gray-300 dark:hover:text-brand-gray-100"
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon}
      </a>
    </TooltipHover>
  );
};
